import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useUser } from "../Pages/Login/UserContext";

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 5%;
  background-color: #282c34;
  color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
`;

const LogoSection = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  a {
    color: #00d8ff;
    text-decoration: none;
    &:hover {
      color: #ffffff;
    }
  }
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const NavMenu = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #282c34;
    padding: 20px 0;
    border-top: 1px solid #444;
  }
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

const NavItem = styled.li`
  margin-left: 20px;

  a,
  button {
    color: #ffffff;
    text-decoration: none;
    font-size: 0.9rem;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #00d8ff;
    }
  }

  @media (max-width: 768px) {
    margin: 15px 0;
    font-size: 1.1rem;
  }
`;

const WelcomeMessage = styled.span`
  font-size: 0.8rem;
  color: #bbb;
  margin-right: 15px;
  @media (max-width: 768px) {
    margin: 0 0 10px 0;
  }
`;

const HamburgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  span {
    height: 2px;
    width: 25px;
    background: white;
    margin-bottom: 4px;
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

function Header() {
  const { user, isLoggedIn } = useUser();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    console.log("ユーザー情報またはログイン状態が変更されました。");
  }, [user, isLoggedIn]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    window.location.href = "/Login?reason=timeout";
  };

  return (
    <HeaderWrapper>
      <LogoSection>
        <Link to="/" onClick={closeMenu}>
          無謀度No.1 夢応援
        </Link>
      </LogoSection>

      <HamburgerMenu onClick={toggleMenu}>
        <span />
        <span />
        <span />
      </HamburgerMenu>

      <NavMenu isOpen={isOpen}>
        <NavList>
          {isLoggedIn && user ? (
            <>
              <WelcomeMessage>ようこそ、{user.userID}さん</WelcomeMessage>
              <NavItem>
                <Link to="/Site" onClick={closeMenu}>
                  サイトについて
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/Ranking" onClick={closeMenu}>
                  ランキング
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/AchievedRanking" onClick={closeMenu}>
                  達成者
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/Register" onClick={closeMenu}>
                  夢を宣言
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/MyPage" onClick={closeMenu}>
                  マイページ
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/TermsOfService" onClick={closeMenu}>
                  規約
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/Contact" onClick={closeMenu}>
                  問い合わせ
                </Link>
              </NavItem>
              <NavItem>
                <button
                  onClick={() => {
                    handleLogout();
                    closeMenu();
                  }}
                >
                  ログアウト
                </button>
              </NavItem>
            </>
          ) : (
            <>
              <NavItem>
                <Link to="/Site" onClick={closeMenu}>
                  サイトについて
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/Ranking" onClick={closeMenu}>
                  ランキング
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/AchievedRanking" onClick={closeMenu}>
                  達成者
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/MemberRegisterView" onClick={closeMenu}>
                  無料登録
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/Login" onClick={closeMenu}>
                  ログイン
                </Link>
              </NavItem>
              <NavItem>
                <Link to="/TermsOfService" onClick={closeMenu}>
                  規約
                </Link>
              </NavItem>
            </>
          )}
        </NavList>
      </NavMenu>
    </HeaderWrapper>
  );
}

export default Header;
